import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const gtmSelector = '#google-tag-manager-script';
	const gtmElem = document.querySelector(gtmSelector);

	if (!gtmElem) {
		return;
	}

	const { Gtm } = await import('./gtm');

	const gtm = new Gtm();
	gtm.init();
});
